module.exports = __webpack_public_path__ + "assets/img/OperationHomepage.eede41cc.png";